import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Modal, Spin } from 'antd';
import { VDSSalesCancellationForm } from '../../forms';
import {
  generateSalesCancellationRequestToVDSXML,
  parseResponse,
} from '../../utils/vdsHelpers';
import { sendSalesCancellationRequestToVDS } from '../../actions/actionHelpers/endpoints';

export class VDSSalesCancellationModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    hideModal: PropTypes.func.isRequired,
    data: PropTypes.any,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: '',
      request: '',
      response: null,
    };
  }

  hideModal = () => {
    const { hideModal } = this.props;
    this.clearMessages();
    hideModal();
  };

  clearMessages = () => {
    this.setState({ error: '', request: '', response: null });
  };

  send = async (values) => {
    this.clearMessages();
    const xml = generateSalesCancellationRequestToVDSXML(values);
    this.setState({ loading: true, request: xml, response: null });
    try {
      const responseObject = await sendSalesCancellationRequestToVDS({ xml });
      const response = parseResponse(responseObject);
      this.setState({
        loading: false,
        error: response.error ? 'Viga andmete saatmisel VDS-i' : '',
        response,
      });
    } catch (error) {
      console.error(error);
      const response = { error: error.message };
      this.setState({
        loading: false,
        error: 'Viga andmete saatmisel VDS-i',
        response,
      });
    }
  };

  render() {
    const { show, data } = this.props;
    const { loading, error, response, request } = this.state;

    return show ? (
      <Modal
        onCancel={this.hideModal}
        open
        footer={false}
        title={'Müügipakkumise osaline või täielik tühistus'}
        width="80vw"
      >
        <Spin spinning={loading}>
          <VDSSalesCancellationForm
            onSubmit={this.send}
            request={request}
            response={response}
            onReset={this.clearMessages}
            data={data}
          >
            {!error && !!response && (
              <Alert
                message={'Andmed saadeti VDS-ile'}
                type="success"
                closable
              />
            )}
            {!!error && <Alert message={error} type="error" closable />}
          </VDSSalesCancellationForm>
        </Spin>
      </Modal>
    ) : null;
  }
}

export default VDSSalesCancellationModal;
